import { GameUI } from "game/gameUI/GameUI";
import { translate } from "game/translate"
import { Popups } from "ui/types/popups";

export const TutorialCompletedSpiderPopup = () => {
    const handleCloseBtnClick = () => {
        GameUI.closePopup(Popups.TUTORIAL_COMPLETED_SPIDER);
        document.dispatchEvent(new CustomEvent('closeModal', { detail: { id: 'tutorial_completed_spider', confirm: false, button: document.querySelector('.close') } }));
    }

    const handlePlayBtnClick = () => {
        GameUI.closePopup(Popups.TUTORIAL_COMPLETED_SPIDER, true);
        document.dispatchEvent(new CustomEvent('closeModal', { detail: { id: 'tutorial_completed_spider', confirm: true } }));
    }
    
    return (
        <div id="tutorial_completed_spider" role="tooltip" className="tutorial_completed_spider modals_area active">
            <div className="wrapper">
                <div className="text_content">
                    <span className="modals_area-title">{translate("tutorial_completed_title")}</span>
                    <img loading="lazy" className="modals_area_img" src="/assets/tutorial/tutorial_completed_spider.webp" />
                    <p className="modals_area-text">{translate("tutorial_completed_text")}</p>
                    <div className="feedback_btn-wrap">
                        <button type="button" className="discard_btn close" onClick={handleCloseBtnClick}>{translate("tutorial_restart_button")}</button>
                        <button type="button" className="modals_area-btn" onClick={handlePlayBtnClick}>{translate("tutorial_play_btn")}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}




